import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './MatrixQuote.module.scss';

import { getRandomInt } from '../../../helpers';

const translationMap = ['one', 'two', 'three'];

function MatrixQuote() {
  const { t } = useTranslation();

  const message = useMemo(() => {
    const number = getRandomInt(translationMap.length);

    return translationMap[number];
  }, []);

  return <p className={styles.paragraph}>{t(`matrix_quotes.${message}`)}</p>;
}

export default MatrixQuote;
